/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef } from "react";
import useApiInventariosCaja from "../../api/taller/useApiInventariosCaja";
import useForm from "../../shared/forms/useForm";
import Field from "../../shared/forms/Field";
import { Button } from "primereact/button";
import Form from "../../shared/forms/Form";
import { Dialog } from "primereact/dialog";
import FormInputFile from "../../shared/forms/FormFields/FormInputFile";
import FieldTextBox from "../../shared/controls/fieldTextBox";
import FormCalendar from "../../shared/forms/FormFields/FormCalendar";
import moment from "moment";
import { Toast } from "primereact/toast";

const SubirInventario = ({ visible, onCancel, onSaved }) => {
  const api = useApiInventariosCaja();
  const toast = useRef(null);
  const { values, onChange } = useForm({
    hora: moment().format("HH:mm"),
    fecha: moment().startOf("day")._d,
  });

const onSave = async () => {
    const formData = new FormData();
    formData.append("file", values.inventario.file);

    const fecha =
        moment(values.fecha).format("YYYY-MM-DD") +
        " " +
        values.hora;

    const respuesta = await api.subirInventario(fecha, formData);

    const mensajes = Array.isArray(respuesta)
        ? respuesta
        : Array.isArray(respuesta?.data)
            ? respuesta.data
            : [];

    const cajasConPase = mensajes.filter((mensaje) =>
        String(mensaje).toLowerCase().includes("pase de salida")
    );

    const cajas = cajasConPase.map((mensaje) =>
        String(mensaje).match(/la caja\s+(\S+)/i)?.[1] ?? mensaje
    );

    await onSaved();

    if (cajas.length > 0) {
        setTimeout(() => {
            toast.current?.show({
                severity: "warn",
                summary: "Cajas no actualizadas",
                detail:
                    `${cajas.length} caja${cajas.length === 1 ? "" : "s"} ` +
                    `no se actualizaron porque tienen pase de salida: ` +
                    cajas.join(", "),
                life: 3000
            });
        }, 100);
    }
};

  return (
    <>
            <Toast ref={toast} position="top-right" />
      <Dialog
        header={`Subir Inventario`}
        visible={visible}
        style={{ width: "400px" }}
        onHide={onCancel}
      >
        <Form values={values} onChange={onChange} className={`form-container`}>
          <Field
            label="Inventario (Excel)"
            field={"inventario"}
            fileTypes={".xlsx"}
            render={FormInputFile}
          />
          <Field label="Fecha" field={"fecha"} render={FormCalendar} />
          <Field
            label="hora"
            field={"hora"}
            render={({ value, onChange }) => (
              <FieldTextBox
                type="time"
                value={value}
                onChange={(hora) => onChange(hora, "fecha")}
              />
            )}
          />
        </Form>

        <div className="form-footer">
          <Button
            label="Subir"
            className="p-button-outlined"
            type="button"
            onClick={onSave}
          />
        </div>
      </Dialog>
    </>
  );
};

export default SubirInventario;
